import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import { useEffect } from "react";


const GET_CONSULTANT_EXPENSE_REPORTS = gql`
  query ConsultantExpenseReports($consultantUuid: ID!, $sliceNumber: Int!) {
    consultantExpenseReports(expenseReportsRequest: { consultantUuid: $consultantUuid, sliceNumber: $sliceNumber }) {
      expenses {
        uuid
        expenseReportFileUuid
        createdAt
        invoiceDate
         category {
            accountingAccountNumber
            labelFr
            labelEn
            label
            uuid
            }
        status
        amountExcludingVat
        impactsOverflow
        currency
        paymentDate
        invoiceIssuer
        countryCode
        countryCode
        invoiceIssuer
        comment
        totalAmount
        boondManagerId
        vatList {
          vatRate
          vatAmount
            vatUuid
        }
          adminComment
      }
      hasNext
    }
  }
`;



export const useConsultantExpenseReports = (consultantUuid, sliceNumber) => {
    const { loading, error, data, refetch } = useQuery(GET_CONSULTANT_EXPENSE_REPORTS, {
        variables: { consultantUuid, sliceNumber },
    });

    useEffect(() => {
        refetch()
    }, [sliceNumber])

    return { loading, error, consultantExpenseReports: data?.consultantExpenseReports, refetch };
};
